import React from "react";
import {
  StyledIconButton,
  StyledPowerIcon,
  StyledLockIcon,
  StyledSettings,
  StyledPlus,
  IconButtonProps,
  StyledLogOut,
} from "./styled";

export type PresenterProps = {
  iconName: IconTypes;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
} & IconButtonProps;

export enum IconTypes {
  POWER = "Power",
  LOCK = "Lock",
  SETTINGS = "Settings",
  PLUS = "Plus",
  LOGOUT = "Logout",
}

const IconPicker = (iconName: IconTypes) => {
  switch (iconName) {
    case IconTypes.POWER:
      return <StyledPowerIcon />;
    case IconTypes.LOCK:
      return <StyledLockIcon />;
    case IconTypes.SETTINGS:
      return <StyledSettings />;
    case IconTypes.PLUS:
      return <StyledPlus />;
    case IconTypes.LOGOUT:
      return <StyledLogOut />;
  }
};

export const IconButtonPresenter: React.FC<PresenterProps> = ({
  iconName,
  disabled,
  onClick,
  ...rest
}) => {
  return (
    <StyledIconButton onClick={onClick} disabled={disabled} {...rest}>
      {IconPicker(iconName)}
    </StyledIconButton>
  );
};

IconButtonPresenter.defaultProps = {
  iconName: IconTypes.PLUS,
  size: "large",
  variant: "primary",
};
